var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"answer"},[_c('Message',{attrs:{"type":_vm.answerMessageType}},[_c('code',[_vm._v(_vm._s(_vm.sparql))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }